import React, {useCallback, useContext, useState} from 'react';
import {Field, Form, Formik} from 'formik';
import Button from '@mui/material/Button';
import axios from 'axios';
import {Box, Paper, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Page from "../../components/ui/Page";
import DownloadIcon from "@mui/icons-material/Download";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import ZiggyContext from "../../store/ziggy-context";
import {DateTime} from "luxon";
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const currentYearMonth = DateTime.now().toFormat("yyyy-LL");

const initialValues = {
    endDate: currentYearMonth,
    startDate: currentYearMonth,
};


export default function Logistics() {
    const [loading, setLoading] = useState(false);

    const ziggyCtx = useContext(ZiggyContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleDownload = useCallback(async (values) => {
        setLoading(true)

        const {startDate, endDate} = values;

        const excelDateToEpoch = (ym) =>
            Math.floor(DateTime.fromFormat(ym, "yyyy-LL", {zone: "utc"})
                .startOf("month")
                .toSeconds());

        const startYearMonth = startDate ? excelDateToEpoch(startDate) : '';
        const endYearMonth = endDate ? excelDateToEpoch(endDate) : '';

        let url = `/logistics/report/order-details?start=${startYearMonth}&end=${endYearMonth}`;

        axios.get(url, {
            responseType: 'blob', headers: {'Error-Message': ''}
        }).then((response) => {

            const filename = `logistics_${startDate}_${endDate}.xlsx`;
            const urlObject = window.URL || window.webkitURL;
            const downloadUrl = urlObject.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                urlObject.revokeObjectURL(downloadUrl);
            }, 100);


        }).finally(() => {
            setLoading(false)

        });

    }, [ziggyCtx.warehouse])


    return <Page>
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={loading}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh',
            p: {xs: 1.5, sm: 3}
        }}>
            <Paper variant="outlined" sx={{p: {xs: 2, sm: 4}, width: {xs: '100%', sm: 'auto'}}}>
                <Formik initialValues={initialValues} onSubmit={handleDownload}>
                    {(form) => (
                        <Form>
                            <Stack direction={{xs: 'column', sm: 'row'}} spacing={2}
                                   sx={{alignItems: {xs: 'stretch', sm: 'center'}}}>
                                <Field name="startDate">
                                    {({field}) => (
                                        <DatePicker
                                            views={['year', 'month']}
                                            openTo="month"
                                            label="Start Date"
                                            value={field.value ? dayjs(field.value, 'YYYY-MM') : null}
                                            onChange={(newValue) => form.setFieldValue('startDate', newValue ? newValue.format('YYYY-MM') : '')}
                                            slotProps={{textField: {size: 'small', fullWidth: isMobile}}}
                                        />
                                    )}
                                </Field>
                                <Field name="endDate">
                                    {({field}) => (
                                        <DatePicker
                                            views={['year', 'month']}
                                            openTo="month"
                                            label="End Date"
                                            value={field.value ? dayjs(field.value, 'YYYY-MM') : null}
                                            onChange={(newValue) => form.setFieldValue('endDate', newValue ? newValue.format('YYYY-MM') : '')}
                                            slotProps={{textField: {size: 'small', fullWidth: isMobile}}}
                                        />
                                    )}
                                </Field>

                                <Button type="submit"
                                        disabled={form.values.startDate.length === 0 || form.values.endDate.length === 0}
                                        variant="contained" color="primary"
                                        startIcon={<DownloadIcon/>}
                                >
                                    Download
                                </Button>
                            </Stack>
                        </Form>)}
                </Formik>
            </Paper>
        </Box>
    </Page>
};
